import { MediaType, Orientation } from './enums';
import { KuxEventWithParam } from './events';

export enum VideoAdExposureAction {
  adBrkSrt = 'AD_BRK_SRT',
  adFtch = 'AD_FTCH',
  adPlay = 'AD_PLAY',
  adSkip = 'AD_SKP',
  adClk = 'AD_CLK',
  close = 'CLOSE',
  adBrkEnd = 'AD_BRK_END',
  custom1 = 'CUSTOM_1',
  custom2 = 'CUSTOM_2',
  custom3 = 'CUSTOM_3',
}

export class VideoAdExposureEventsArgs extends KuxEventWithParam {
  // @ts-expect-error TODO Fix
  action: VideoAdExposureAction;
  // @ts-expect-error TODO Fix
  assetId: string;
  /**
   * only for mobile
   */
  screenOrientation?: Orientation;
  /**
   * Identifier for the ad
   */
  // @ts-expect-error TODO Fix
  adId: string;
  // @ts-expect-error TODO Fix
  adServerId: string;
  /**
   * Duration in seconds for the full ad
   */
  // @ts-expect-error TODO Fix
  duration: number;
  /**
   * Location within the ad the action happened
   */
  // @ts-expect-error TODO Fix
  location: string;
  /**
   * Media ID of the content in which the ad was engage
   */
  // @ts-expect-error TODO Fix
  mediaId: string;
  /**
   * Media type of the content in which the ad was engaged
   */
  // @ts-expect-error TODO Fix
  mediaType: MediaType;
  /**
   * custom data
   */
  custom?: string;

  constructor(data: VideoAdExposureEventsArgs) {
    super('videoAdExposure', data as KuxEventWithParam);
    Object.assign(this, data);
  }
}
